import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppStore } from '../../../store/useAppStore';
import { logger } from '@/utils/logger';

/**
 * Restores an invite gateway route after a signed-out user signs in.
 * The gateway owns preview, acceptance, and issue states.
 */
export const useProjectJoin = () => {
    const navigate = useNavigate();
    const user = useAppStore((state) => state.auth.user);

    useEffect(() => {
        if (!user) return;

        const pending = sessionStorage.getItem('pendingJoin');
        if (!pending) return;

        try {
            const parsed = JSON.parse(pending) as unknown;
            sessionStorage.removeItem('pendingJoin');
            sessionStorage.removeItem('pendingJoinAuthMode');

            if (!parsed || typeof parsed !== 'object') return;

            const pendingJoin = parsed as Record<string, unknown>;
            const token = typeof pendingJoin.token === 'string' ? pendingJoin.token : '';
            const projectId = typeof pendingJoin.projectId === 'string' ? pendingJoin.projectId : '';
            const invitationId = typeof pendingJoin.invitationId === 'string' ? pendingJoin.invitationId : '';
            const orgId = typeof pendingJoin.orgId === 'string' ? pendingJoin.orgId : '';

            if (token && orgId && projectId && invitationId) {
                void navigate(`/invite/${encodeURIComponent(orgId)}/${encodeURIComponent(projectId)}/${encodeURIComponent(invitationId)}/${encodeURIComponent(token)}`, { replace: true });
            }
        } catch (error: unknown) {
            logger.error('Error parsing pending join:', error);
            sessionStorage.removeItem('pendingJoin');
            sessionStorage.removeItem('pendingJoinAuthMode');
        }
    }, [user, navigate]);

    return { isJoining: false };
};
